import { Component } from '@angular/core';
import { UserAdminView, UserAdminViewAdapter } from '../../../models/user-admin-view';
import { UsersService } from '../../../services/users.service';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { catchError, debounceTime, map, Observable, of } from 'rxjs';

@Component({
  selector: 'app-users-list',
  standalone: true,
  imports: [TranslatePipe, CommonModule],
  templateUrl: './users-list.component.html',
  styleUrl: './users-list.component.scss'
})
export class UsersListComponent {

  users$ : Observable<UserAdminView[]> = this.getUsers();
  errorMessage: string | null = null;

  constructor(private usersService: UsersService, private userAdminViewAdapter: UserAdminViewAdapter) { }

    private getUsers(): Observable<UserAdminView[]> {
      return this.fetchUsers();
    }

    private fetchUsers(): Observable<UserAdminView[]> {
      return this.usersService.getUsersForAdmin().pipe(
        map((data: any[]) => data.map(item => this.userAdminViewAdapter.adapt(item))),
        catchError((error: any) => {
          this.errorMessage = 'Error during users fetch : ' + error.message;
          return of([]); // return empty table to avoid binding error
        })
      );
    }
}
